<template>
  <button
    :class="classes"
    v-if="event"
    :href="event.url"
    target="_blank"
    :style="{ '--accent-color': event.calendarColor }"
  >
    <span class="title">
      <span class="dot" :style="{ backgroundColor: event.calendarColor }"></span>
      <span>{{ sanitizedSummary }}</span>
    </span>

    <!-- Show time if NOT all-day -->
    <span v-if="!event.allDay" class="time"> {{ start }}{{ end }} </span>

    <!-- Show start-time if NOT all-day -->
    <span v-if="!event.allDay" class="start-time">
      {{ startTime }}
    </span>

    <!-- Show location if NOT all-day and location exists -->
    <span v-if="!event.allDay && event.location.length > 0" class="location">
      {{ event.location }}
    </span>

    <!-- Optional: show description if you want -->
    <span class="description">{{ event.description }}</span>
  </button>
</template>


<script>
import { format, parse } from 'date-fns'

export default {
  name: 'Asd20CalendarEventButton',
  props: {
    event: Object,
    large: { type: Boolean, default: false },
  },
  computed: {
    classes() {
      return {
        'asd20-calendar-event-button': true,
        'asd20-calendar-event-button--large': this.large,
        'asd20-calendar-event-button--all-day': this.event.allDay,
      }
    },
    startTime() {
      return format(
        parse(this.event.start, "yyyy-MM-dd'T'HH:mm:ssX", new Date()),
        'h:mm aa'
      )
    },
    start() {
      return format(
        parse(this.event.start, "yyyy-MM-dd'T'HH:mm:ssX", new Date()),
        'h:mm aa, MMMM dd yyyy'
      )
    },
    end() {
      return (
        ' to ' +
        format(
          parse(this.event.end, "yyyy-MM-dd'T'HH:mm:ssX", new Date()),
          'h:mm aa, MMMM dd yyyy'
        )
      )
    },
    sanitizedSummary() {
      return this.sanitizeSummary(this.event.summary)
    },
  },
  methods: {
    sanitizeSummary(summary) {
      if (!summary) return summary
      const pattern = /vs\.[^>]*>Multiple Schools/
      return summary.replace(pattern, 'vs. Multiple Schools')
    },
  },
}


</script>


<style lang="scss" scoped>
@import '../../../design/_mixins.scss';
@import '../../../design/_variables.scss';

$base: var(--website-card__reverse-background-color);
$primary: var(--color__primary);
$accent: var(--color__accent);

.asd20-calendar-event-button {
  --accent-color: #{$accent};
  display: flex;
  border: none;
  text-align: left;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  flex-wrap: wrap;
  flex-shrink: 0;

  box-sizing: border-box;
  line-height: 1;
  font-size: 1em;
  color: $base;
  padding: space(0.5);

  cursor: pointer;
  transition: all 0.1s ease-in-out;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

  background: transparent;

  &--all-day,
  &:hover {
    background: rgba($accent, 0.2);
  }

  &:focus {
    background: rgba($accent, 0.2);
    @include asd20-focus;
  }

  &:active {
    color: white;
    background: var(--color__primary);
    .title {
      color: white;
    }
  }

  .title {
    display: flex;
    align-items: center;
    align-items: baseline;
    font-size: 0.875rem;
    line-height: 1.2;
    color: $primary;
    font-weight: bold;
    // margin-bottom: 0.5em;
    &::before {
      content: '';
      position: relative;
      display: block;
      width: 6px;
      height: 6px;
      margin-right: space(0.25);
      padding: 0;
      margin-bottom: 0;
      line-height: 0;
      background: var(--accent-color);
      border-radius: 50%;
      flex-shrink: 0;
    }
  }
  .start-time {
    display: none;
    font-size: 0.75rem;
    font-weight: bold;
    color: var(--color__accent-s20);
    white-space: nowrap;
    margin-right: space(0.5);
  }
  .time {
    font-size: 0.75rem;
    line-height: 1.25;
    display: none;
    margin-bottom: 0.5em;
    &::before {
      content: 'When: ';
      font-weight: bold;
    }
  }
  .location {
    font-size: 0.75rem;
    margin-bottom: 0.5em;
    display: none;
    margin-right: space(0.5);
    // white-space: nowrap;
  }
  .description {
    display: none;
    margin-bottom: 0.5em;
  }
  &--large {
    .title {
      flex-basis: 100%;
      font-size: 1rem;
    }
    .start-time {
      margin-top: space(0.125);
      display: block;
      font-size: 0.875rem;
      margin-left: space(0.5);
    }
    .location {
      display: block;
      margin-top: space(0.125);
      margin-bottom: 0;
      font-size: 0.875rem;
      margin-left: space(0.5);
    }
  }
  &--all-day {
    .start-time {
      display: none;
    }
  }
}
</style>
